module.exports = __webpack_public_path__ + "img/tutorial_query-2.33b15134.png";